// Single off-switch for which version statuses appear in the compare
// dropdowns. Trim this array to hide statuses without touching call sites.
export const COMPARABLE_VERSION_STATUSES = ['DRAFT', 'ACTIVE', 'DEPRECATED', 'RETIRED'];

// Sentinel selector value for "the unsaved working copy" (edit-mode tab only).
export const WORKING_COPY_VALUE = '__working_copy__';

// Stacked side-by-side dimension sections, in render order.
export const COMPARE_DIMENSIONS = [
	{ key: 'fields', label: 'Fields' },
	{ key: 'rules', label: 'Conditional Rules' },
	{ key: 'rootMeta', label: 'Root Metadata' },
	{ key: 'customValidators', label: 'Custom Validators' },
	{ key: 'fieldOrder', label: 'Field Ordering' },
];

/**
 * Resolve a serialized version record to a plain JSON Schema object.
 * Prefers the XML-preserving elementSchemaJson clone, falls back to
 * elementSchema; parses JSON strings; returns null when neither is usable.
 */
export function resolveVersionSchema(version) {
	if (!version || typeof version !== 'object') return null;
	const raw = version.elementSchemaJson || version.elementSchema || null;
	if (!raw) return null;
	if (typeof raw === 'string') {
		try {
			return JSON.parse(raw);
		} catch {
			return null;
		}
	}
	return raw;
}
